// extracted by mini-css-extract-plugin
export var actions = "_rx-4";
export var item = "_rx-1";
export var price = "_rx-3";
export var quantity = "_rx-2";
export var table = "_rx-0";